
export default [
  {
    "title": "Use React hooks inside an MDX story in Storybook",
    "devTo": "https://dev.to/cbillowes/use-react-hooks-inside-an-mdx-story-in-storybook-33pl",
    "abstract": "Do you need to use a React hook inside Storybook? Here's a quick snippet to show you how to do so.\n",
    "date": new Date("2022-01-13T00:00:00.000Z"),
    "cover": "/hero/storybook.png",
    "creditLink": "https://storybook.js.org/",
    "creditSource": "storybook.js.org",
    "tags": [
      "Technical",
      "Tip",
      "Storybook",
      "React",
      "JavaScript"
    ],
    "content": "```javascript\n<Story name=\"With hooks\">\n  {() => {\n    const [count, setCount] = useState(0);\n    return <button onClick={() => setCount(count + 1)}>Clicked {count} time(s)</button>;\n  }}\n</Story>\n```",
    "_meta": {
      "filePath": "2022-01-13-react-hooks-inside-mdx-story.md",
      "fileName": "2022-01-13-react-hooks-inside-mdx-story.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-13-react-hooks-inside-mdx-story"
    },
    "slug": "/scribbles/use-react-hooks-inside-an-mdx-story-in-storybook",
    "timeToRead": 1,
    "type": "scribble",
    "number": 1,
    "previous": {
      "slug": "/scribbles/how-to-kill-an-orphaned-next-js-dev-server",
      "title": "How to kill an orphaned Next.js dev server",
      "number": 30
    },
    "next": {
      "slug": "/scribbles/how-to-reference-a-local-webpack-npm-package",
      "title": "How to reference a local Webpack npm package",
      "number": 2
    }
  },
  {
    "title": "How to reference a local Webpack npm package",
    "devTo": "https://dev.to/cbillowes/how-to-reference-a-local-webpack-npm-package-20g4",
    "abstract": "Not all npm packages have to come from a remote npm registry. Here's a quick snippet on how to reference one locally.\n",
    "date": new Date("2022-01-14T00:00:00.000Z"),
    "cover": "/hero/npm.png",
    "creditLink": "https://en.wikipedia.org/wiki/Npm_(software)#/media/File:Npm-logo.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tip",
      "Webpack",
      "JavaScript",
      "npm"
    ],
    "content": "With the help of this question and answer from [Stack Overflow](https://stackoverflow.com/questions/15806241/how-to-specify-local-modules-as-npm-package-dependencies):\n\nInstall the local npm package using the file path. Check node_modules to see the installed package.\n\n```bash\nnpm install --save ../\n```\n\n(or `--save-dev` depending on the requirements) && (in this example the package exists in the parent directory)\n\nNote that you only specify the path to the package. No filename should be referenced.\n\nThe package will be referenced with the local file package. Note the file: protocol.\n\n```bash\n{\n  \"name\": \"venom\",\n  \"scripts\": {\n    \"build\": \"webpack\"\n  },\n  \"dependencies\": {\n    \"hulk\": \"file:../\"\n  }\n}\n```",
    "_meta": {
      "filePath": "2022-01-14-reference-local-webpack-npm-package.md",
      "fileName": "2022-01-14-reference-local-webpack-npm-package.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-14-reference-local-webpack-npm-package"
    },
    "slug": "/scribbles/how-to-reference-a-local-webpack-npm-package",
    "timeToRead": 1,
    "type": "scribble",
    "number": 2,
    "previous": {
      "slug": "/scribbles/use-react-hooks-inside-an-mdx-story-in-storybook",
      "title": "Use React hooks inside an MDX story in Storybook",
      "number": 1
    },
    "next": {
      "slug": "/scribbles/how-to-sort-stories-alphabetically-in-storybook-6-2-",
      "title": "How to sort stories alphabetically in Storybook (6.2)",
      "number": 3
    }
  },
  {
    "title": "How to sort stories alphabetically in Storybook (6.2)",
    "devTo": "https://dev.to/cbillowes/how-to-sort-stories-alphabetically-in-storybook-62-3e61",
    "abstract": "You could have a lot of stories in Storybook. Here's a quick snippet on how to sort them alphabetically.\n",
    "date": new Date("2022-01-17T00:00:00.000Z"),
    "cover": "/hero/storybook.png",
    "creditLink": "https://storybook.js.org/",
    "creditSource": "storybook.js.org",
    "tags": [
      "Technical",
      "Tip",
      "Storybook",
      "JavaScript"
    ],
    "content": "```javascript:title=.storybook/preview.js\nexport const parameters = {\n  options: {\n    storySort: (a, b) => {\n      const aId = a[1].kind;\n      const bId = b[1].kind;\n      return aId === bId\n        ? 0\n        : aId.localeCompare(bId, undefined, { numeric: true });\n    }\n  },\n};\n```",
    "_meta": {
      "filePath": "2022-01-17-sort-stories-in-storybook.md",
      "fileName": "2022-01-17-sort-stories-in-storybook.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-17-sort-stories-in-storybook"
    },
    "slug": "/scribbles/how-to-sort-stories-alphabetically-in-storybook-6-2-",
    "timeToRead": 1,
    "type": "scribble",
    "number": 3,
    "previous": {
      "slug": "/scribbles/how-to-reference-a-local-webpack-npm-package",
      "title": "How to reference a local Webpack npm package",
      "number": 2
    },
    "next": {
      "slug": "/scribbles/how-to-search-through-all-files-in-your-web-application-in-google-chrome",
      "title": "How to search through all files in your web application in Google Chrome",
      "number": 4
    }
  },
  {
    "title": "How to search through all files in your web application in Google Chrome",
    "devTo": "https://dev.to/cbillowes/how-to-search-through-all-files-in-your-web-application-in-google-chrome-3p0a",
    "abstract": "Need to find some text in your web application in your browser? Here's a simple guide for Google Chrome using the powerful search in DevTools.\n",
    "date": new Date("2022-01-18T00:00:00.000Z"),
    "tags": [
      "Technical",
      "Tip",
      "Chrome",
      "DevTools"
    ],
    "content": "> I am running Version 97.0.4692.71 (Official Build) (arm64) to date.\n\n## Why?\n\nUse this feature to find text in any resource served by the web server.\nIt's handy for searching for things where the location is sometimes uncertain.\n\n## How\n\nThere are two ways I know of:\n\n### Approach 1\n\n(the simplest)\n\n1. Go to the Developer Tools\n1. In the kebab menu to the far right (right next to the close button - on the left)\n1. You can then open the Search tab by clicking on Search.\n\n### Approach 2\n\n(let's you browse through files before hand)\n\n1. Go to the Developer Tools\n1. Go to the Sources tab (you can rearrange your tabs by dragging them around)\n1. Locate your domain (in my case it's Storybook on localhost:6007)\n1. Right-click on the domain name and click on Search in all files\n\n![Google Chrome DevTools](https://res.cloudinary.com/practicaldev/image/fetch/s--XDcon--I--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/qx0b9qkbyxyoe1gs7rsr.png \"Google Chrome DevTools\")",
    "_meta": {
      "filePath": "2022-01-18-search-through-all-files-chrome.md",
      "fileName": "2022-01-18-search-through-all-files-chrome.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-18-search-through-all-files-chrome"
    },
    "slug": "/scribbles/how-to-search-through-all-files-in-your-web-application-in-google-chrome",
    "timeToRead": 1,
    "cover": "/hero/default-01.jpg",
    "type": "scribble",
    "number": 4,
    "previous": {
      "slug": "/scribbles/how-to-sort-stories-alphabetically-in-storybook-6-2-",
      "title": "How to sort stories alphabetically in Storybook (6.2)",
      "number": 3
    },
    "next": {
      "slug": "/scribbles/how-to-find-text-anywhere-in-your-git-repository-from-the-very-beginning",
      "title": "How to find text anywhere in your Git repository from the very beginning",
      "number": 5
    }
  },
  {
    "title": "How to find text anywhere in your Git repository from the very beginning",
    "devTo": "https://dev.to/cbillowes/how-to-find-text-anywhere-in-your-git-repository-from-the-very-beginning-29d9",
    "abstract": "Need to find some text in your Git repository, even if it was deleted a long time ago? Here's a simple command to help you do just that.\n",
    "date": new Date("2022-01-19T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "tags": [
      "Technical",
      "Git",
      "Tip",
      "Terminal"
    ],
    "content": "```bash\ngit log -S password\n```\n\n- [Stack Overflow](https://stackoverflow.com/questions/4468361/search-all-of-git-history-for-a-string) - Search all of Git history for a string\n- [Stack Overflow](https://stackoverflow.com/questions/1337320/how-to-grep-git-commit-diffs-or-contents-for-a-certain-word) - How to grep Git commit diffs or contents for a certain word",
    "_meta": {
      "filePath": "2022-01-19-find-text-anywhere-in-git.md",
      "fileName": "2022-01-19-find-text-anywhere-in-git.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-19-find-text-anywhere-in-git"
    },
    "slug": "/scribbles/how-to-find-text-anywhere-in-your-git-repository-from-the-very-beginning",
    "timeToRead": 1,
    "type": "scribble",
    "number": 5,
    "previous": {
      "slug": "/scribbles/how-to-search-through-all-files-in-your-web-application-in-google-chrome",
      "title": "How to search through all files in your web application in Google Chrome",
      "number": 4
    },
    "next": {
      "slug": "/scribbles/how-to-get-a-list-of-git-commits-for-a-given-file",
      "title": "How to get a list of Git commits for a given file",
      "number": 6
    }
  },
  {
    "title": "How to get a list of Git commits for a given file",
    "devTo": "https://dev.to/cbillowes/how-to-get-a-list-of-git-commits-for-a-given-file-15og",
    "abstract": "Need to get a list of all Git commits for a specific file? Here's a simple command to help you do just that.\n",
    "date": new Date("2022-01-19T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "tags": [
      "Technical",
      "Git",
      "Terminal",
      "Tip"
    ],
    "content": "> This includes cases where the file has been renamed.\n\n```bash\ngit log --follow filename.ext\n```\n\nMore [Stack Overflow](https://stackoverflow.com/questions/30443906/git-log-follow-show-all-commits-including-merges):\n`git log --follow`, show all commits including merges",
    "_meta": {
      "filePath": "2022-01-19-get-a-list-of-git-commits-for-a-given-file.md",
      "fileName": "2022-01-19-get-a-list-of-git-commits-for-a-given-file.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-19-get-a-list-of-git-commits-for-a-given-file"
    },
    "slug": "/scribbles/how-to-get-a-list-of-git-commits-for-a-given-file",
    "timeToRead": 1,
    "type": "scribble",
    "number": 6,
    "previous": {
      "slug": "/scribbles/how-to-find-text-anywhere-in-your-git-repository-from-the-very-beginning",
      "title": "How to find text anywhere in your Git repository from the very beginning",
      "number": 5
    },
    "next": {
      "slug": "/scribbles/how-to-use-a-different-email-address-in-git-in-sub-directories",
      "title": "How to use a different email address in Git in sub directories",
      "number": 7
    }
  },
  {
    "title": "How to use a different email address in Git in sub directories",
    "devTo": "https://dev.to/cbillowes/how-to-use-a-different-email-address-in-git-in-sub-directories-jp9",
    "abstract": "I want to override my personal email address I use for Git with my work email address in my work directory without manually changing it each time.\n",
    "date": new Date("2022-01-19T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "tags": [
      "Technical",
      "Git",
      "Terminal",
      "Tip"
    ],
    "content": "I want to override my personal email address I use for Git with my work\nemail address in my work directory without manually changing it each time.\n\n````text:title=~/path/to/work/directory/.gitconfig\n# any customization/overrides can be added here\n[user]\n        name = Clarice Bouwer\n        email = clarice@example.com\n        ```\n````\n\n```text:title=~/.gitconfig\n[includeIf \"gitdir:~/path/to/work/directory/\"]\n    path = ~/path/to/work/directory/.gitconfig\n```\n\n```bash\ncd ~/\ngit config user.email # should be your default config email\n\ncd ~/path/to/work/directory\ngit config user.email # should be your override email\n```",
    "_meta": {
      "filePath": "2022-01-19-use-different-email-in-git-sub-directories.md",
      "fileName": "2022-01-19-use-different-email-in-git-sub-directories.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-19-use-different-email-in-git-sub-directories"
    },
    "slug": "/scribbles/how-to-use-a-different-email-address-in-git-in-sub-directories",
    "timeToRead": 1,
    "type": "scribble",
    "number": 7,
    "previous": {
      "slug": "/scribbles/how-to-get-a-list-of-git-commits-for-a-given-file",
      "title": "How to get a list of Git commits for a given file",
      "number": 6
    },
    "next": {
      "slug": "/scribbles/how-to-kill-processes-running-on-localhost-macos-",
      "title": "How to kill processes running on localhost (macOS)",
      "number": 8
    }
  },
  {
    "title": "How to kill processes running on localhost (macOS)",
    "devTo": "https://dev.to/cbillowes/how-to-kill-processes-running-on-localhost-macos-1h5o",
    "abstract": "Sometimes processes running on localhost can hang onto ports even after the process has ended. Here's a quick guide on how to find and kill those processes on macOS.\n",
    "date": new Date("2022-01-20T00:00:00.000Z"),
    "tags": [
      "Technical",
      "Tip",
      "Terminal",
      "MacOS"
    ],
    "content": "## Motivation\n\nSometimes a process, like a web server or running Clojure REPL, closes unexpectedly but the port is never released. I'd need to find that process and kill it so that I can rightfully claim my port back.\n\n## Find the process\n\n```\nnetstat -vanp tcp | grep \"*.\"\n```\n\nIt will return something like this (note that the table scrolls to the right):\n\n```\ntcp4       0      0  *.3000                 *.* LISTEN      131072 131072  46834      0 0x0100 0x00000106\ntcp46      0      0  *.8085                 *.* LISTEN      131072 131072  29254      0 0x0100 0x00000006\ntcp46      0      0  *.8321                 *.* LISTEN      131072 131072  29254      0 0x0100 0x00000006\ntcp46      0      0  *.8080                 *.* LISTEN      131072 131072  29254      0 0x0100 0x00000006\ntcp4       0      0  *.61350                *.* LISTEN      131072 131072  29278      0 0x0100 0x00000006\ntcp4       0      0  127.0.0.1.61933        *.* LISTEN      131072 131072   2951      0 0x0100 0x00000106\ntcp4       0      0  127.0.0.1.45623        *.* LISTEN      131072 131072   2951      0 0x0100 0x00000106\ntcp4       0      0  127.0.0.1.49489        *.* LISTEN      131072 131072   2951      0 0x0100 0x00000106\ntcp4       0      0  127.0.0.1.49488        *.* LISTEN      131072 131072   2951      0 0x0100 0x00000106\ntcp4       0      0  127.0.0.1.16494        *.* LISTEN      131072 131072   2901      0 0x0000 0x0000020f\ntcp4       0      0  127.0.0.1.15393        *.* LISTEN      131072 131072   2901      0 0x0000 0x0000020f\ntcp4       0      0  127.0.0.1.15292        *.* LISTEN      131072 131072   2901      0 0x0000 0x0000020f\ntcp4       0      0  127.0.0.1.6463         *.* LISTEN      131072 131072    838      0 0x0100 0x00000106\n```\n\n## Identify the process\n\nThe 3rd column after `LISTEN` is the pid. Taking the first entry (a process running on `:3000`), I can safely grab its pid of `46834` and inspect it.\n\n```\nps aux | grep 46834\n```\n\nIt will return something like this:\n\n```\nclarice          46834   0.0  1.3 441950208 219760 s001  S+    9:06pm   0:25.95 /Users/clarice/.nvm/versions/node/v16.13.0/bin/node /Users/clarice/Workspace/demos/react/node_modules/react-scripts/scripts/start.js\nclarice          58003   0.0  0.0 408628368   1632 s010  S+    4:52am   0:00.00 grep --color=auto --exclude-dir=.bzr --exclude-dir=CVS --exclude-dir=.git --exclude-dir=.hg --exclude-dir=.svn --exclude-dir=.idea --exclude-dir=.tox 46834\n```\n\nBased on this output, the first entry gives me the most information. I can see it's a Node.js application and it's coming from `demos/react` app. That's the correct one so I can kill it.\n\n_The 2nd entry is always present on a terminal grep. I believe it to be the coloured output of the terminal._\n\n## Kill the process\n\nNow that I have the right process, I can kill it using `kill 46834`. If the process is stubborn and keen on staying alive, you can force it by using `kill -9 46834`\n\n> (I think these commands are Unix based so it should work on Linux too)",
    "_meta": {
      "filePath": "2022-01-20-kill-processes-running-on-localhost.md",
      "fileName": "2022-01-20-kill-processes-running-on-localhost.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-20-kill-processes-running-on-localhost"
    },
    "slug": "/scribbles/how-to-kill-processes-running-on-localhost-macos-",
    "timeToRead": 3,
    "cover": "/hero/default-01.jpg",
    "type": "scribble",
    "number": 8,
    "previous": {
      "slug": "/scribbles/how-to-use-a-different-email-address-in-git-in-sub-directories",
      "title": "How to use a different email address in Git in sub directories",
      "number": 7
    },
    "next": {
      "slug": "/scribbles/how-to-see-the-contents-of-stashed-changes-in-git",
      "title": "How to see the contents of stashed changes in Git",
      "number": 9
    }
  },
  {
    "title": "How to see the contents of stashed changes in Git",
    "devTo": "https://dev.to/cbillowes/how-to-see-the-contents-of-stashed-changes-in-git-4aj8",
    "abstract": "Need to see what changes you have stashed in Git without applying them? Here's a simple command to help you do just that.\n",
    "date": new Date("2022-01-24T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "tags": [
      "Technical",
      "Tip",
      "Git",
      "Terminal"
    ],
    "content": "```bash\ngit stash show -p stash@{0}\n```\n\nWhere `0` is the indexed location of the item in the stash. Find all items in the stash using:\n\n```bash\ngit stash list\n```\n\n- `git help stash`\n- https://stackoverflow.com/questions/3573623/is-it-possible-to-preview-stash-contents-in-git\n- https://stackoverflow.com/questions/10725729/see-whats-in-a-stash-without-applying-it",
    "_meta": {
      "filePath": "2022-01-24-see-contents-of-stashed-changes-in-git.md",
      "fileName": "2022-01-24-see-contents-of-stashed-changes-in-git.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-24-see-contents-of-stashed-changes-in-git"
    },
    "slug": "/scribbles/how-to-see-the-contents-of-stashed-changes-in-git",
    "timeToRead": 1,
    "type": "scribble",
    "number": 9,
    "previous": {
      "slug": "/scribbles/how-to-kill-processes-running-on-localhost-macos-",
      "title": "How to kill processes running on localhost (macOS)",
      "number": 8
    },
    "next": {
      "slug": "/scribbles/how-to-recover-a-file-from-another-branch-in-git",
      "title": "How to recover a file from another branch in Git",
      "number": 10
    }
  },
  {
    "title": "How to recover a file from another branch in Git",
    "devTo": "https://dev.to/cbillowes/how-to-recover-a-file-from-another-branch-in-git-30p",
    "abstract": "Need to recover a file from another branch in Git without switching branches? Here's a simple command to help you do just that.\n",
    "date": new Date("2022-01-25T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "tags": [
      "Technical",
      "Tip",
      "Git",
      "Terminal"
    ],
    "content": "```bash\ngit show branch:filename.ext > path/to/file.ext\n```\n\nWhere branch can be any ref including a branch name, tag, HEAD.\n\nThanks to this [Stack Overflow](https://stackoverflow.com/questions/7856416/view-a-file-in-a-different-git-branch-without-changing-branches) reference.",
    "_meta": {
      "filePath": "2022-01-25-how-to-recover-a-file-from-another-branch-in-git.md",
      "fileName": "2022-01-25-how-to-recover-a-file-from-another-branch-in-git.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-01-25-how-to-recover-a-file-from-another-branch-in-git"
    },
    "slug": "/scribbles/how-to-recover-a-file-from-another-branch-in-git",
    "timeToRead": 1,
    "type": "scribble",
    "number": 10,
    "previous": {
      "slug": "/scribbles/how-to-see-the-contents-of-stashed-changes-in-git",
      "title": "How to see the contents of stashed changes in Git",
      "number": 9
    },
    "next": {
      "slug": "/scribbles/name-css-split-chunks-using-minicssextractplugin",
      "title": "Name CSS Split Chunks using MiniCssExtractPlugin",
      "number": 11
    }
  },
  {
    "title": "Name CSS Split Chunks using MiniCssExtractPlugin",
    "devTo": "https://dev.to/cbillowes/code-snippet-name-css-split-chunks-using-minicssextractplugin-fg2/",
    "abstract": "When using Webpack with Split Chunks and MiniCssExtractPlugin, you may want to name the emitted CSS files with a content hash to bust the cache. Here's a quick snippet on how to do just that.\n",
    "date": new Date("2022-03-17T00:00:00.000Z"),
    "cover": "/hero/webpack.png",
    "creditLink": "https://en.wikipedia.org/wiki/File:Webpack.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tip",
      "JavaScript",
      "Webpack"
    ],
    "content": "> React: 17.0.2\n> Webpack: 5.67.0\n> Webpack CLI: 4.9.1\n> mini-css-extract-plugin 2.5.3\n\n## Snippet\n\n```\nconst MiniCssExtractPlugin = require('mini-css-extract-plugin');\nmodule.exports = {\n  ...\n  output: {\n    optimization: {\n      ...\n      minimizer: [\n        new MiniCssExtractPlugin({\n          chunkFilename: (pathData) => {\n            return `${pathData.chunk.id}.[contenthash].css`;\n          },\n        }),\n      ],\n    },\n  },\n  ...\n};\n```\n\n## Objective\n\nBust the cache for CSS files that are emitted on build using Webpack 5 with [Split Chunks](https://webpack.js.org/plugins/split-chunks-plugin/).\n\n## Set up\n\n1. `import` one or more CSS files inside a React component.\n1. A single CSS file for that chunk is emitted on build.\n1. This file will be requested when the component is imported downstream.\n1. When it is requested over HTTP the file is most likely cached and will need to be busted upon new releases.\n\n## Solution\n\nConfigure MiniCssExtractPlugin, using the snippet above, by assigning a naming function to the chunkFilename attribute on the webpack config file.\n\nThe `[contenthash]` placeholder produces the md4-hash of the output file content (e.g. [contenthash].js -> 4ea6ff1de66c537eb9b2.js). [See more](https://webpack.js.org/concepts/under-the-hood/#output).",
    "_meta": {
      "filePath": "2022-03-17-name-css-split-chunks-using-mini-css-extract-plugin.md",
      "fileName": "2022-03-17-name-css-split-chunks-using-mini-css-extract-plugin.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-03-17-name-css-split-chunks-using-mini-css-extract-plugin"
    },
    "slug": "/scribbles/name-css-split-chunks-using-minicssextractplugin",
    "timeToRead": 1,
    "type": "scribble",
    "number": 11,
    "previous": {
      "slug": "/scribbles/how-to-recover-a-file-from-another-branch-in-git",
      "title": "How to recover a file from another branch in Git",
      "number": 10
    },
    "next": {
      "slug": "/scribbles/how-to-sort-your-package-json-dependencies",
      "title": "How to sort your package.json dependencies",
      "number": 12
    }
  },
  {
    "title": "How to sort your package.json dependencies",
    "devTo": "https://dev.to/cbillowes/how-to-sort-your-packagejson-dependencies-1gi1",
    "abstract": "Want to keep your package.json dependencies sorted alphabetically without installing an extra package? Here's a quick npm command to help you do just that.\n",
    "date": new Date("2022-04-18T00:00:00.000Z"),
    "cover": "/hero/npm.png",
    "creditLink": "https://en.wikipedia.org/wiki/Npm_(software)#/media/File:Npm-logo.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tip",
      "npm",
      "JavaScript"
    ],
    "content": "```bash\nnpm r -S example; npm r -D example\n```\n\nis short hand for `npm remove --save anything` and `npm remove --save-dev whatever`.\n\n\"example\" is just the name of a package.\nYou can use it verbatim because it will most likely not be in your package.json.\nYour packages are sorted by running npm remove even if the package \"example\" doesn't exist.\n\n---\n\nThanks to this [question](https://stackoverflow.com/questions/34438465/is-there-a-way-to-alphabetize-package-json-without-installing-a-package) on Stack Overflow.",
    "_meta": {
      "filePath": "2022-04-18-sort-package-json-dependencies.md",
      "fileName": "2022-04-18-sort-package-json-dependencies.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-04-18-sort-package-json-dependencies"
    },
    "slug": "/scribbles/how-to-sort-your-package-json-dependencies",
    "timeToRead": 1,
    "type": "scribble",
    "number": 12,
    "previous": {
      "slug": "/scribbles/name-css-split-chunks-using-minicssextractplugin",
      "title": "Name CSS Split Chunks using MiniCssExtractPlugin",
      "number": 11
    },
    "next": {
      "slug": "/scribbles/how-to-write-stdout-both-to-the-terminal-and-a-file",
      "title": "How to write stdout both to the terminal and a file",
      "number": 13
    }
  },
  {
    "title": "How to write stdout both to the terminal and a file",
    "devTo": "https://dev.to/cbillowes/how-to-write-stdout-both-to-the-terminal-and-a-file-3dod",
    "abstract": "Sometimes you may want to see the output of a command in the terminal while also saving that output to a file for later reference. Here's a quick guide on how to do just that.\n",
    "date": new Date("2022-05-04T00:00:00.000Z"),
    "tags": [
      "Technical",
      "Tip",
      "Terminal"
    ],
    "content": "Below I use the [tee](https://phoenixnap.com/kb/linux-tee#:~:text=What%20Does%20tee%20Command%20Do,can%20precede%20or%20follow%20it.) command to write the output of an `npm run build` script to both to the terminal and to a log file.\n\n```bash\nnpm run build | tee ./logs/build.log\n```",
    "_meta": {
      "filePath": "2022-05-04-how-to-write-stdout-both-to-terminal-and-file.md",
      "fileName": "2022-05-04-how-to-write-stdout-both-to-terminal-and-file.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-05-04-how-to-write-stdout-both-to-terminal-and-file"
    },
    "slug": "/scribbles/how-to-write-stdout-both-to-the-terminal-and-a-file",
    "timeToRead": 1,
    "cover": "/hero/default-01.jpg",
    "type": "scribble",
    "number": 13,
    "previous": {
      "slug": "/scribbles/how-to-sort-your-package-json-dependencies",
      "title": "How to sort your package.json dependencies",
      "number": 12
    },
    "next": {
      "slug": "/scribbles/how-to-debug-a-specific-gatsby-package-on-build",
      "title": "How to debug a specific Gatsby package on build",
      "number": 14
    }
  },
  {
    "title": "How to debug a specific Gatsby package on build",
    "devTo": "https://dev.to/cbillowes/how-to-debug-a-specific-gatsby-package-on-build-3bid",
    "abstract": "Need to get verbose logs for a specific Gatsby package during a build? Here's a quick snippet on how to do just that.\n",
    "date": new Date("2022-05-28T00:00:00.000Z"),
    "cover": "/hero/gatsby.png",
    "credit": "gatsbyjs",
    "creditLink": "https://www.gatsbyjs.org/",
    "tags": [
      "Technical",
      "Tip",
      "Terminal",
      "Gatsby"
    ],
    "content": "I got an error and needed to get verbose logs for a particular package during a Gatsby build.\n\nI came across this issue on GitHub with reference to a [DEBUG env var](https://github.com/gatsbyjs/gatsby/issues/34051#issuecomment-1077425897) that can be set to get better logs.\n\n```bash\nDEBUG=gatsby:gatsby-plugin-sharp npm run build\n```",
    "_meta": {
      "filePath": "2022-05-28-how-to-debug-a-specific-gatsby-package-on-build.md",
      "fileName": "2022-05-28-how-to-debug-a-specific-gatsby-package-on-build.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-05-28-how-to-debug-a-specific-gatsby-package-on-build"
    },
    "slug": "/scribbles/how-to-debug-a-specific-gatsby-package-on-build",
    "timeToRead": 1,
    "type": "scribble",
    "number": 14,
    "previous": {
      "slug": "/scribbles/how-to-write-stdout-both-to-the-terminal-and-a-file",
      "title": "How to write stdout both to the terminal and a file",
      "number": 13
    },
    "next": {
      "slug": "/scribbles/how-to-minify-css-files-via-copywebpackplugin-for-webpack5",
      "title": "How to minify CSS files via CopyWebpackPlugin for Webpack5",
      "number": 15
    }
  },
  {
    "title": "How to minify CSS files via CopyWebpackPlugin for Webpack5",
    "devTo": "https://dev.to/cbillowes/how-to-minify-css-files-via-copywebpackplugin-for-webpack5-4fc0",
    "abstract": "When using Webpack, you may want to minify CSS files that are simply copied to an output directory. Here's a quick snippet on how to do just that using CopyWebpackPlugin and cssnano.\n",
    "date": new Date("2022-06-15T00:00:00.000Z"),
    "cover": "/hero/webpack.png",
    "creditLink": "https://en.wikipedia.org/wiki/File:Webpack.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "npm",
      "Node.js",
      "Webpack",
      "JavaScript"
    ],
    "content": "## Goal\n\nEmit minified vendor-based CSS files on build.\n\n## Dependencies\n\n```json:title=package.json\n\"copy-webpack-plugin\": \"11.0.0\",\n\"cssnano\": \"5.1.11\",\n\"webpack\": \"5.70.0\",\n\"webpack-cli\": \"4.9.2\"\n```\n\n## Elaborate\n\nI have a few unminified vendor CSS files that I simply want to minify and copy to an output directory. These files were not being transformed by terser probably due to the chain of command (steps in which the build is processed).\n\nAll CSS files matching this regex `/src/vendors/**/*.css` are **transform**ed using `postcss` and `cssnano` in conjunction with the `CopyWebpackPlugin`.\n\n## Code\n\n```js:title=webpage.config.js\n...\nplugins: [\n  new CopyWebpackPlugin({\n    patterns: [\n      {\n        from: 'src/vendors/**/*.css',\n        to: './css/[name].[contenthash].min[ext]',\n        transform: (content, path) => {\n          return postcss([cssnano])\n            .process(content, {\n              from: path,\n            })\n            .then((result) => {\n              return result.css;\n            });\n        },\n      },\n    ],\n  }),\n],\n...\n```",
    "_meta": {
      "filePath": "2022-06-15-how-to-minify-css-files-via-webpack-plugin.md",
      "fileName": "2022-06-15-how-to-minify-css-files-via-webpack-plugin.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-06-15-how-to-minify-css-files-via-webpack-plugin"
    },
    "slug": "/scribbles/how-to-minify-css-files-via-copywebpackplugin-for-webpack5",
    "timeToRead": 1,
    "type": "scribble",
    "number": 15,
    "previous": {
      "slug": "/scribbles/how-to-debug-a-specific-gatsby-package-on-build",
      "title": "How to debug a specific Gatsby package on build",
      "number": 14
    },
    "next": {
      "slug": "/scribbles/how-to-unmap-a-var-from-a-clojure-namespace",
      "title": "How to unmap a var from a Clojure namespace",
      "number": 16
    }
  },
  {
    "title": "How to unmap a var from a Clojure namespace",
    "devTo": "https://dev.to/cbillowes/how-to-unmap-a-var-from-a-clojure-namespace-n5c",
    "abstract": "When working in a Clojure REPL, you may need to unmap a var from a namespace. This can be useful when redefining multimethods.\n",
    "date": new Date("2022-06-21T00:00:00.000Z"),
    "cover": "/hero/clojure.jpg",
    "credit": "Tom & Rich Hickey",
    "creditLink": "https://en.wikipedia.org/wiki/Clojure",
    "tags": [
      "Technical",
      "Tip",
      "Clojure"
    ],
    "content": "I was working with a multimethod that I needed to redefine in my REPL and came across [this](https://clojuredocs.org/clojure.core/defmulti) doc.\n\nThere is an entry that states if you are in the REPL and need to redefine then you will need to unmap the var because defmulti won't allow you to redef.\n\nThis is how:\n\n```clojure\n(ns-unmap *ns* 'something)\n```",
    "_meta": {
      "filePath": "2022-06-21-how-to-unmap-a-var-from-clojure-ns.md",
      "fileName": "2022-06-21-how-to-unmap-a-var-from-clojure-ns.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-06-21-how-to-unmap-a-var-from-clojure-ns"
    },
    "slug": "/scribbles/how-to-unmap-a-var-from-a-clojure-namespace",
    "timeToRead": 1,
    "type": "scribble",
    "number": 16,
    "previous": {
      "slug": "/scribbles/how-to-minify-css-files-via-copywebpackplugin-for-webpack5",
      "title": "How to minify CSS files via CopyWebpackPlugin for Webpack5",
      "number": 15
    },
    "next": {
      "slug": "/scribbles/edit-your-web-page-content-directly-in-chrome",
      "title": "Edit your web page content directly in Chrome",
      "number": 17
    }
  },
  {
    "title": "Edit your web page content directly in Chrome",
    "devTo": "https://dev.to/cbillowes/pro-tip-edit-your-web-page-content-from-the-browser-window-350i",
    "abstract": "Need to quickly edit the content of a web page for prototyping or testing? Here's a quick tip on how to do just that directly from your browser.\n",
    "date": new Date("2022-07-22T00:00:00.000Z"),
    "tags": [
      "Technical",
      "Chrome",
      "Tip"
    ],
    "content": "Executing `document.designMode = \"on\"` in the browser console will let you click and type\nanywhere you want on your page. This is helpful if you want to experiment with text\ndirectly on the page instead of in the DOM.",
    "_meta": {
      "filePath": "2022-07-22-edit-content-from-browser.md",
      "fileName": "2022-07-22-edit-content-from-browser.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-07-22-edit-content-from-browser"
    },
    "slug": "/scribbles/edit-your-web-page-content-directly-in-chrome",
    "timeToRead": 1,
    "cover": "/hero/default-01.jpg",
    "type": "scribble",
    "number": 17,
    "previous": {
      "slug": "/scribbles/how-to-unmap-a-var-from-a-clojure-namespace",
      "title": "How to unmap a var from a Clojure namespace",
      "number": 16
    },
    "next": {
      "slug": "/scribbles/how-to-run-a-single-clojure-test-from-the-terminal-using-leiningen",
      "title": "How to run a single Clojure test from the terminal using Leiningen",
      "number": 18
    }
  },
  {
    "title": "How to run a single Clojure test from the terminal using Leiningen",
    "devTo": "https://dev.to/cbillowes/how-to-run-a-single-clojure-test-from-the-terminal-using-leiningen-e1l",
    "abstract": "You may want to target and run a specific test or set of tests when testing your code so that you don't keep executing the entire suite each time you make changes to specific tests. This creates a faster feedback loop for you to build and fix code. Here's a quick guide on how to do just that using Leiningen.\n",
    "date": new Date("2022-08-08T00:00:00.000Z"),
    "cover": "/hero/clojure.jpg",
    "credit": "Tom & Rich Hickey",
    "creditLink": "https://en.wikipedia.org/wiki/Clojure",
    "tags": [
      "Technical",
      "Clojure",
      "Terminal"
    ],
    "content": "You may want to target and run a specific test or set of tests when testing\nyour code so that you don't keep executing the entire suite each time you\nmake changes to specific tests. This creates a faster feedback loop for you\nto build and fix code. Usually tests are executed with Leiningen using `lein test`.\nYou can extend this command to meet the necessary objectives.\n\n```bash\nlein test :only my.namespace/my-test\n```\n\nThanks to [this](https://stackoverflow.com/questions/41484746/clojure-test-and-leinigen-how-to-run-just-a-single-test-from-command-line) question and answer on Stack Overflow. :heart:",
    "_meta": {
      "filePath": "2022-08-08-run-single-clojure-test.md",
      "fileName": "2022-08-08-run-single-clojure-test.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-08-08-run-single-clojure-test"
    },
    "slug": "/scribbles/how-to-run-a-single-clojure-test-from-the-terminal-using-leiningen",
    "timeToRead": 1,
    "type": "scribble",
    "number": 18,
    "previous": {
      "slug": "/scribbles/edit-your-web-page-content-directly-in-chrome",
      "title": "Edit your web page content directly in Chrome",
      "number": 17
    },
    "next": {
      "slug": "/scribbles/redact-values-in-a-map-using-clojure-walk-postwalk",
      "title": "Redact values in a map using clojure.walk/postwalk",
      "number": 19
    }
  },
  {
    "title": "Redact values in a map using clojure.walk/postwalk",
    "devTo": "https://dev.to/cbillowes/redact-values-in-a-map-using-clojurewalkpostwalk-1ne",
    "abstract": "When working with Clojure data structures, you may need to redact certain values. Here's a quick snippet on how to do just that using clojure.walk/postwalk.\n",
    "date": new Date("2022-08-22T00:00:00.000Z"),
    "cover": "/hero/clojure.jpg",
    "credit": "Tom & Rich Hickey",
    "creditLink": "https://en.wikipedia.org/wiki/Clojure",
    "tags": [
      "Technical",
      "Clojure"
    ],
    "content": "```bash\n(defn redact\n  [data]\n  (walk/postwalk\n   (fn [node]\n     (if (and (vector? node) (= :id-number (first node)))\n       [:id-number \"REDACTED\"]\n       node))\n   data))\n```",
    "_meta": {
      "filePath": "2022-08-22-clojure.walk-postwalk.md",
      "fileName": "2022-08-22-clojure.walk-postwalk.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-08-22-clojure.walk-postwalk"
    },
    "slug": "/scribbles/redact-values-in-a-map-using-clojure-walk-postwalk",
    "timeToRead": 1,
    "type": "scribble",
    "number": 19,
    "previous": {
      "slug": "/scribbles/how-to-run-a-single-clojure-test-from-the-terminal-using-leiningen",
      "title": "How to run a single Clojure test from the terminal using Leiningen",
      "number": 18
    },
    "next": {
      "slug": "/scribbles/why-you-will-see-the-error-loading-chunk-d-failed",
      "title": "Why you will see the error 'Loading chunk \\d+ failed'",
      "number": 20
    }
  },
  {
    "title": "Why you will see the error 'Loading chunk \\d+ failed'",
    "devTo": "https://dev.to/cbillowes/why-you-will-see-the-error-loading-chunk-d-failed-1ne4",
    "abstract": "When using Webpack with code splitting, you may see the error 'Loading chunk \\d+ failed' in the browser console. Here's a quick explanation of why this can happen.\n",
    "date": new Date("2022-09-06T00:00:00.000Z"),
    "cover": "/hero/webpack.png",
    "creditLink": "https://en.wikipedia.org/wiki/File:Webpack.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Node.js",
      "JavaScript",
      "Webpack"
    ],
    "content": "I know of the following reasons why chunks cannot be downloaded:\n\n## Network errors\n\nInspect the network in the browser dev tools to find out more information about the errors.\n\n## Resources not found\n\nThey don't exist in the correct directory (output > publicPath).\nTry access the resource/asset via its URL in the browser to see if it exists.\n\n## Package corruption\n\nSomething is wonky with the node_modules. In my case, I manipulated my modules locally\nto avoid having to push to npm on each change. This caused corruption which resulted\nin chunks that did exist in the output path were deemed not found.\nTo rectify this, delete the modules and re-install.\n\n```bash\nrm -rf node_modules\nnpm install # or `npm i` for short\n```\n\n## Duplicate styled-components\n\n[Warning](https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page) explanation on styled-components site.",
    "_meta": {
      "filePath": "2022-09-06-loading-chunk-failed.md",
      "fileName": "2022-09-06-loading-chunk-failed.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-09-06-loading-chunk-failed"
    },
    "slug": "/scribbles/why-you-will-see-the-error-loading-chunk-d-failed",
    "timeToRead": 1,
    "type": "scribble",
    "number": 20,
    "previous": {
      "slug": "/scribbles/redact-values-in-a-map-using-clojure-walk-postwalk",
      "title": "Redact values in a map using clojure.walk/postwalk",
      "number": 19
    },
    "next": {
      "slug": "/scribbles/hack-to-fix-gatsby-image-process-from-stalling",
      "title": "Hack to fix Gatsby image process from stalling",
      "number": 21
    }
  },
  {
    "title": "Hack to fix Gatsby image process from stalling",
    "abstract": "If your Gatsby image processing is stalling during development, here's a quick hack to help fix it by setting the CPU count.\n",
    "date": new Date("2022-10-09T00:00:00.000Z"),
    "cover": "/hero/gatsby.png",
    "credit": "gatsbyjs",
    "creditLink": "https://www.gatsbyjs.org/",
    "tags": [
      "Technical",
      "Hack",
      "Terminal",
      "Gatsby"
    ],
    "content": "Build stuck at running jobs (image transformation)\n\n```bash\nnpm run clean && GATSBY_CPU_COUNT=8 npm run develop\n```\n\n- [GitHub #34051](https://github.com/gatsbyjs/gatsby/issues/34051)",
    "_meta": {
      "filePath": "2022-10-09-gatsby-image-process-stalling.md",
      "fileName": "2022-10-09-gatsby-image-process-stalling.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-10-09-gatsby-image-process-stalling"
    },
    "slug": "/scribbles/hack-to-fix-gatsby-image-process-from-stalling",
    "timeToRead": 1,
    "type": "scribble",
    "number": 21,
    "previous": {
      "slug": "/scribbles/why-you-will-see-the-error-loading-chunk-d-failed",
      "title": "Why you will see the error 'Loading chunk \\d+ failed'",
      "number": 20
    },
    "next": {
      "slug": "/scribbles/how-to-show-filenames-in-code-snippets-in-gatsby-in-markdown",
      "title": "How to show filenames in code snippets in Gatsby in Markdown",
      "number": 22
    }
  },
  {
    "title": "How to show filenames in code snippets in Gatsby in Markdown",
    "abstract": "Want to show filenames above code snippets in your Gatsby Markdown files? Here's a quick guide on how to do just that.\n",
    "date": new Date("2022-10-09T00:00:00.000Z"),
    "cover": "/hero/gatsby.png",
    "credit": "gatsbyjs",
    "creditLink": "https://www.gatsbyjs.org/",
    "tags": [
      "Technical",
      "Tip",
      "JavaScript",
      "Gatsby"
    ],
    "content": "With the [gatsby-remark-code-titles](https://www.gatsbyjs.com/plugins/gatsby-remark-code-titles/) plugin.\n\n```bash\nnpm install gatsby-remark-code-titles --save-dev\n```\n\n```javascript:title=gatsby-config.js\nplugins: [\n  {\n    resolve: 'gatsby-transformer-remark',\n    options: {\n      plugins: [\n        {\n          resolve: 'gatsby-remark-code-titles',\n          options: {\n            className: 'your-custom-class-name',\n          },\n        }, // IMPORTANT: this must be ahead of other plugins that use code blocks\n      ],\n    },\n  },\n];\n```\n\nCustom title gets injected and then needs to be styled. Example from docs:\n\n```css\n.gatsby-remark-code-title {\n  margin-bottom: -0.6rem;\n  padding: 0.5em 1em;\n  font-family:\n    Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\",\n    \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco,\n    \"Courier New\", Courier, monospace;\n\n  background-color: black;\n  color: white;\n  z-index: 0;\n\n  border-top-left-radius: 0.3em;\n  border-top-right-radius: 0.3em;\n}\n```\n\n## Usage\n\n````markdown\n````js:title=example-file.js\nalert('how cool is this!');\n```.\n````\n````\n\n> This plugin will parse the Markdown AST, pluck the title, and then “clean” the code snippet language for further processing.\n> In other words, the plugin will create the following structure, injecting a custom div with the title:\n\n````markdown\n<div class=\"gatsby-code-title\">example-file.js</div>\n```js\nalert('how cool is this');\n```.\n````",
    "_meta": {
      "filePath": "2022-10-09-how-to-show-code-filenames.md",
      "fileName": "2022-10-09-how-to-show-code-filenames.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-10-09-how-to-show-code-filenames"
    },
    "slug": "/scribbles/how-to-show-filenames-in-code-snippets-in-gatsby-in-markdown",
    "timeToRead": 1,
    "type": "scribble",
    "number": 22,
    "previous": {
      "slug": "/scribbles/hack-to-fix-gatsby-image-process-from-stalling",
      "title": "Hack to fix Gatsby image process from stalling",
      "number": 21
    },
    "next": {
      "slug": "/scribbles/utility-to-fix-npm-dependencies",
      "title": "Utility to fix npm dependencies",
      "number": 23
    }
  },
  {
    "title": "Utility to fix npm dependencies",
    "abstract": "If you have outdated, incorrect or unused dependencies in your Node project, here's a quick utility to help you fix them.\n",
    "date": new Date("2022-10-09T00:00:00.000Z"),
    "cover": "/hero/npm.png",
    "creditLink": "https://en.wikipedia.org/wiki/Npm_(software)#/media/File:Npm-logo.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tools",
      "Node.js",
      "JavaScript",
      "Terminal"
    ],
    "content": "There is a utility called **npm-check** that offers the ability to interactively update outdated, incorrect or unused dependencies:\n\n```bash\nnpx npm-check --update\n```\n\nTake a look at the switches. It offers way more than just that.\n\n## Usage\n\n```bash\nnpx npm-check <path> <options>\n# Path = Where to check. Defaults to current directory. Use -g for checking global modules.\n# Options = Choose from the switches available.\n# Help -> npx npm-check --help\n```\n\n## Switches\n\n| Switch            | Description                                                            |\n| ----------------- | ---------------------------------------------------------------------- |\n| -u, --update      | Interactive update.                                                    |\n| -y, --update-all  | Uninteractive update. Apply all updates without prompting.             |\n| -g, --global      | Look at global modules.                                                |\n| -s, --skip-unused | Skip check for unused packages.                                        |\n| -p, --production  | Skip devDependencies.                                                  |\n| -d, --dev-only    | Look at devDependencies only (skip dependencies).                      |\n| -i, --ignore      | Ignore dependencies based on succeeding glob.                          |\n| -E, --save-exact  | Save exact version (x.y.z) instead of caret (^x.y.z) in package.json.  |\n| --specials        | List of depcheck specials to include in check for unused dependencies. |\n| --no-color        | Force or disable color output.                                         |\n| --no-emoji        | Remove emoji support. No emoji in default in CI environments.          |\n| --debug           | Debug output. Throw in a gist when creating issues on github.          |",
    "_meta": {
      "filePath": "2022-10-09-npm-dependency-check.md",
      "fileName": "2022-10-09-npm-dependency-check.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-10-09-npm-dependency-check"
    },
    "slug": "/scribbles/utility-to-fix-npm-dependencies",
    "timeToRead": 2,
    "type": "scribble",
    "number": 23,
    "previous": {
      "slug": "/scribbles/how-to-show-filenames-in-code-snippets-in-gatsby-in-markdown",
      "title": "How to show filenames in code snippets in Gatsby in Markdown",
      "number": 22
    },
    "next": {
      "slug": "/scribbles/how-to-read-node-js-environment-variables",
      "title": "How to read Node.js environment variables",
      "number": 24
    }
  },
  {
    "title": "How to read Node.js environment variables",
    "abstract": "A quick guide on how to read environment variables in your Node.js applications.\n",
    "date": new Date("2022-10-18T00:00:00.000Z"),
    "cover": "/hero/nodejs-lock.png",
    "creditLink": "https://en.wikipedia.org/wiki/Node.js#/media/File:Node.js_logo.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tip",
      "Node.js",
      "JavaScript"
    ],
    "content": "Running a Node app is simple.\n\n```bash:title=bash\nnode panic.js\n```\n\nSometimes you want to add environment variables that either contain sensitive information\nor are contextual to the environment you want to run your app on.\nYou can set them the moment the process is started.\n\n```bash:title=bash\nNUMBER=42 ANIMAL=dolphins PREFIX=don\\'t node panic.js\n```\n\nImagine having to do this approach with multiple vars and for production ready systems where commands\nare written to the logs. Not a good idea. This approach is great for testing though.\n\nTo access these variables in your code, simply prefix the scream case with `process.env.`.\n\n```js:title=panic.js\nconsole.log(`${process.env.NUMBER} is my favorite number.`);\nconsole.log(`${process.env.ANIMAL} are my favorite animals`);\nconsole.log(`${process.env.PREFIX} panic!`);\n```\n\nWhat you do then is create a hidden environment file in the root of your project most commonly named `.env`.\n\n```txt:file=.env\nNUMBER=\"42\"\nANIMAL=\"dolphins\"\nPREFIX=\"don't\"\n```\n\nIf you have multiple environments, you can use [dotenv](https://www.npmjs.com/package/dotenv)\nto load them during runtime.\n\n```js:title=panic.js\nrequire('dotenv').config();\n\nconsole.log(`${process.env.NUMBER} is my favorite number.`);\nconsole.log(`${process.env.ANIMAL} are my favorite animals`);\nconsole.log(`${process.env.PREFIX} panic!`);\n```\n\n> ### Note\n>\n> You don't need to import the `dotenv` Node package into your codebase.\n> Instead run the command below to run the code and do a module to preload (option can be repeated)\n> to **require** the dependency(ies).\n\n```bash:title=bash\nnode --require dotenv/config panic.js\n# or shortened to\nnode -r dotenv/config panic.js\n```\n\nIf you have multiple files for different environments then you can specify the\nfile by appending `dotenv_config_path` to it.\n\n```bash:title=bash\nnode -r dotenv/config panic.js dotenv_config_path=.env-vogsphere\n```\n\nAppend `dotenv_config_debug=true` to the command to print out the values in the file.\n\n## References\n\n- [How to read environment variables from Node.js](https://nodejs.dev/en/learn/how-to-read-environment-variables-from-nodejs/) - Node.js\n- [dotenv](https://www.npmjs.com/package/dotenv)",
    "_meta": {
      "filePath": "2022-10-18-node-envs.md",
      "fileName": "2022-10-18-node-envs.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-10-18-node-envs"
    },
    "slug": "/scribbles/how-to-read-node-js-environment-variables",
    "timeToRead": 2,
    "type": "scribble",
    "number": 24,
    "previous": {
      "slug": "/scribbles/utility-to-fix-npm-dependencies",
      "title": "Utility to fix npm dependencies",
      "number": 23
    },
    "next": {
      "slug": "/scribbles/vs-code-extensions-that-i-use-every-day",
      "title": "VS Code extensions that I use every day",
      "number": 25
    }
  },
  {
    "title": "VS Code extensions that I use every day",
    "abstract": "A list of Visual Studio Code extensions that I use on a daily basis to improve productivity and make life easier as a developer and blogger.\n",
    "date": new Date("2022-11-01T00:00:00.000Z"),
    "cover": "/hero/vscode.png",
    "creditLink": "https://commons.wikimedia.org/wiki/File:Visual_Studio_Code_1.35_icon.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Productivity",
      "VS Code"
    ],
    "content": "I use numerous VS Code extensions to increase productivity\nand make life easier as a developer and blogger. Here are some of them:\n\n## Theme\n\n- [Atom One Dark Theme](https://marketplace.visualstudio.com/items?itemName=akamud.vscode-theme-onedark)\n  is based on Atom's One Dark theme. It is the best rated One Dark theme port in the marketplace, features full Workbench theming.\n\n- [Material Icon Theme](https://marketplace.visualstudio.com/items?itemName=PKief.material-icon-theme).\n\n## Etiquette and cleanliness\n\n- [Code Spell Checker](https://marketplace.visualstudio.com/items?itemName=streetsidesoftware.code-spell-checker)\n  is a basic spell checker that works well with code and documents.\\\n  The goal of this spell checker is to help catch common spelling errors while keeping the number of false positives low.\n\n- [Prettier - Code formatter](https://marketplace.visualstudio.com/items?itemName=esbenp.prettier-vscode).\n\n## Clojure\n\n- [Calva](https://marketplace.visualstudio.com/items?itemName=betterthantomorrow.calva)\n  is an integrated, REPL powered, development environment for enjoyable and productive\\\n  Clojure and ClojureScript programming in Visual Studio Code.\n\n- [clj-kondo](https://marketplace.visualstudio.com/items?itemName=borkdude.clj-kondo)\n  is a linter for Clojure and ClojureScript. This extension bundles a language server\\\n  and client for clj-kondo and requires no additional installation.\n\n## Syntax highlighting\n\n- [Babel JavaScript](https://marketplace.visualstudio.com/items?itemName=mgmcdermott.vscode-language-babel).\n\n## Colors\n\n- [Color Highlight](https://marketplace.visualstudio.com/items?itemName=naumovs.color-highlight)\n  styles css/web colors found in your document.\n\n- [Color Picker](https://marketplace.visualstudio.com/items?itemName=anseki.vscode-color)\n  helper with GUI to generate color codes such as CSS color notations.\n\n## IntelliSense\n\n- [Tailwind CSS IntelliSense](https://marketplace.visualstudio.com/items?itemName=bradlc.vscode-tailwindcss)\n  provides intelligent Tailwind CSS tooling for VS Code.\n\n## Productivity\n\n- [Vim](https://marketplace.visualstudio.com/items?itemName=vscodevim.vim) emulator.\n\n- [Live Server](https://marketplace.visualstudio.com/items?itemName=ritwickdey.LiveServer)\n  launches a development local Server with live reload feature for static & dynamic pages.\n\n- [Todo Tree](https://marketplace.visualstudio.com/items?itemName=Gruntfuggly.todo-tree)\n  shows TODO, FIXME, etc. comment tags in a tree view.\n\n- [Version Lens](https://marketplace.visualstudio.com/items?itemName=pflannery.vscode-versionlens)\n  shows the latest version for each package using code lens.\n\n- [WakaTime](https://marketplace.visualstudio.com/items?itemName=WakaTime.vscode-wakatime)\n  provides metrics, insights, and time tracking automatically generated from your programming activity.",
    "_meta": {
      "filePath": "2022-11-01-vscode-extensions.md",
      "fileName": "2022-11-01-vscode-extensions.md",
      "directory": ".",
      "extension": "md",
      "path": "2022-11-01-vscode-extensions"
    },
    "slug": "/scribbles/vs-code-extensions-that-i-use-every-day",
    "timeToRead": 2,
    "type": "scribble",
    "number": 25,
    "previous": {
      "slug": "/scribbles/how-to-read-node-js-environment-variables",
      "title": "How to read Node.js environment variables",
      "number": 24
    },
    "next": {
      "slug": "/scribbles/optimize-images-for-sharing-on-social-media",
      "title": "Optimize images for sharing on social media",
      "number": 26
    }
  },
  {
    "title": "Optimize images for sharing on social media",
    "abstract": "A simple guide to optimize images on build for social media sharing using Node.js in a Next.js application.\n",
    "date": new Date("2025-12-08T00:00:00.000Z"),
    "cover": "/hero/optimize-image.webp",
    "creditLink": "https://www.freepik.com/pikaso/ai-image-generator",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Image Optimization",
      "Node.js",
      "Next.js"
    ],
    "content": "You can create metadata for social media sharing using optimized images in a format that is universally supported across various platforms.\nWhatsApp, for instance, does not like sharing with webp images, so converting them to JPEG is a good idea.\nLarge images can be slow and rejected by some platforms, so resizing them is beneficial.\n\n## Optimize images\n\nYou will need to install sharp which is a high performance Node.js image processing library to handle programmatic image optimization.\n\n```bash\nnpm install sharp\n```\n\nThis script will convert images to JPEG format, resize them to 400x400 pixels, and set the quality to 80 for optimal sharing on social media platforms.\nYou can adjust the dimensions and quality settings as needed.\n\n```js:title=scripts/optimize-images.js\nconst sharp = require('sharp');\nconst fs = require('fs');\nconst path = require('path');\n\nconst fromPath = process.argv[2];\nconst toPath = process.argv[3];\n\nconsole.log(`🧪 Processing images for social sharing from: ${fromPath} to ${toPath}...`);\n\nfunction processImage(image) {\n  const toExt = '.jpg';\n  // Get extension from image path\n  const ext = path.extname(image).toLowerCase();\n  const basename = path.basename(image);\n  const newBasename = basename.replace(ext, toExt);\n  const outputJpg = path.join(toPath, newBasename);\n\n  if (fs.existsSync(outputJpg)) {\n    console.log(`✅ Image already exists: ${outputJpg}`);\n    return;\n  }\n\n  if (['.DS_Store'].includes(basename)) {\n    console.log(`⏭️ Skipping file: ${image}`);\n    return;\n  }\n\n  sharp(image)\n    .toFormat('jpeg')\n    .jpeg({ quality: 80 })\n    .resize(400, 400, {\n      fit: 'cover',\n      background: { r: 0, g: 0, b: 0, alpha: 0 }\n    })\n    .toFile(outputJpg, (err) => {\n      if (err) {\n        console.error('❌ Conversion failed for ', outputJpg, err);\n      } else {\n        console.log(`✅ Jpg generated from webp: ${outputJpg}`);\n      }\n    });\n}\n\nfunction traverseDirectory(dir) {\n  const files = fs.readdirSync(dir);\n  files.forEach(file => {\n    const fullPath = path.join(dir, file);\n    const stats = fs.statSync(fullPath);\n    if (stats.isDirectory()) {\n      traverseDirectory(fullPath);\n    } else {\n      processImage(fullPath);\n    }\n  });\n}\n\nif (!fs.existsSync(toPath)) {\n  console.log(`🧪 Making directory for ${toPath}...`);\n  fs.mkdirSync(toPath, { recursive: true });\n}\n\nconst stats = fs.statSync(fromPath);\nif (stats.isDirectory()) {\n  traverseDirectory(fromPath)\n} else {\n  processImage(fromPath);\n}\n\nconsole.log('✅ Optimizing images script completed.');\n```\n\nYou can use the script by running the following command in your terminal, replacing the source and destination paths as needed:\n\n```bash\nnode optimize-images.js ./path/to/source/images ./path/to/destination/images\n```\n\n## Run on build\n\nRun this on build using `nodemon` and `concurrently`.\nNodemon will watch for changes in the source images folder and run the optimization script automatically and Concurrently will allow you to run this alongside your development server.\n\n```bash\nnpm install --save-dev nodemon concurrently\n```\n\n```json:title=nodemon.json\n{\n  \"ext\": \"gif,jpg,jpeg,png,webp\",\n  \"watch\": [\n    \"public/**/*\"\n  ],\n  \"exec\": \"node scripts/optimize-images.js public/source public/destination\"\n}\n```\n\nUpdate your `package.json` to include the following scripts:\n\n```json:title=package.json\n\"scripts\": {\n  \"watch\": \"nodemon\",\n  \"dev\": \"concurrently \\\"npm run watch\\\" \\\"next dev\\\"\"\n}\n```\n\n## Page metadata\n\nYou can then reference the optimized images in your Next.js page metadata for social sharing.\nThis example uses Next.js 16 with App Router and TypeScript.\n\n```tsx:title=app/page.js\nexport async function generateMetadata() {\n  const image = '/share/optimized-image.jpg';\n  return {\n    title: 'Some page',\n    description: 'Some description',\n    imageUrl: image,\n    openGraph: {\n      title: 'Some page',\n      description: 'Some description',\n      images: [{\n        url: image,\n        width: 400,\n        height: 400,\n        alt: 'Optimized image for sharing',\n        type: 'image/jpeg'\n      }],\n      type: 'website',\n      publishedTime: '2025-12-08T00:00:00Z',\n    },\n    twitter: {\n      card: 'summary_large_image',\n      title: 'Some page',\n      description: 'Some description',\n      images: [image],\n    },\n    type: 'website',\n  };\n}\n```",
    "_meta": {
      "filePath": "2025-12-08-01-optimize-images-for-sharing.md",
      "fileName": "2025-12-08-01-optimize-images-for-sharing.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-12-08-01-optimize-images-for-sharing"
    },
    "slug": "/scribbles/optimize-images-for-sharing-on-social-media",
    "timeToRead": 3,
    "type": "scribble",
    "number": 26,
    "previous": {
      "slug": "/scribbles/vs-code-extensions-that-i-use-every-day",
      "title": "VS Code extensions that I use every day",
      "number": 25
    },
    "next": {
      "slug": "/scribbles/free-photoshop-like-experience-with-photopea",
      "title": "Free Photoshop-like experience with Photopea",
      "number": 27
    }
  },
  {
    "title": "Free Photoshop-like experience with Photopea",
    "abstract": "Photopea is a free online image editor that works in your browser, allowing you to edit images without installing any software.\n",
    "date": new Date("2025-12-08T00:00:00.000Z"),
    "cover": "/hero/photopea.webp",
    "creditLink": "https://www.photopea.com/",
    "creditSource": "Photopea",
    "tags": [
      "Technical",
      "Image Optimization",
      "Image Editing",
      "Photopea"
    ],
    "content": "When it comes to image editing, many people immediately think of Adobe Photoshop.\nHowever, Photoshop can be rather expensive.\n\nIf you're looking for a free alternative that doesn't require any installation, nor an account, [Photopea](https://www.photopea.com/) is an excellent choice.\n\nPhotopea is a web-based image editor that offers a wide range of features similar to Photoshop.\nIt supports various file formats, including PSD, XCF, Sketch, and more.\n\nYou can use Photopea for tasks such as photo retouching, graphic design, and even creating web graphics.\n\nThe interface is user-friendly and closely resembles that of Photoshop, making it easy for those familiar with Photoshop to get started.\n\nOne of the standout features of Photopea is its ability to work directly in your browser.\nThis means you don't need to download or install any software, and you can access your projects from any device with an internet connection.\n\nAdditionally, Photopea is free to use, although there is a premium version available that removes ads and offers additional features.\n\nOverall, Photopea is a powerful and convenient tool for anyone in need of a free image editing solution.\nWhether you're a professional designer or just someone looking to make quick edits to your photos, Photopea is definitely worth checking out.",
    "_meta": {
      "filePath": "2025-12-08-02-easy-image-editing.md",
      "fileName": "2025-12-08-02-easy-image-editing.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-12-08-02-easy-image-editing"
    },
    "slug": "/scribbles/free-photoshop-like-experience-with-photopea",
    "timeToRead": 2,
    "type": "scribble",
    "number": 27,
    "previous": {
      "slug": "/scribbles/optimize-images-for-sharing-on-social-media",
      "title": "Optimize images for sharing on social media",
      "number": 26
    },
    "next": {
      "slug": "/scribbles/automatically-update-npm-packages-in-one-command",
      "title": "Automatically update npm packages in one command",
      "number": 28
    }
  },
  {
    "title": "Automatically update npm packages in one command",
    "abstract": "Automatically update all npm packages in your project with a single command using npm-check-updates.\n",
    "date": new Date("2025-12-19T00:00:00.000Z"),
    "cover": "/hero/npm.png",
    "creditLink": "https://en.wikipedia.org/wiki/Npm_(software)#/media/File:Npm-logo.svg",
    "creditSource": "Wikipedia",
    "tags": [
      "Technical",
      "Tools",
      "Node.js",
      "JavaScript",
      "Terminal"
    ],
    "content": "```bash\nnpx npm-check-updates -u && npm install\n```\n\nThis command uses the `npm-check-updates` utility to automatically update all the dependencies in your `package.json` file to their latest versions.\nThe `-u` flag tells it to upgrade the versions in `package.json`, and the `&& npm install` part installs the updated packages.\n\nIf you don't want to install updates right away, drop the `&& npm install` part.",
    "_meta": {
      "filePath": "2025-12-19-automatically-update-packages.md",
      "fileName": "2025-12-19-automatically-update-packages.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-12-19-automatically-update-packages"
    },
    "slug": "/scribbles/automatically-update-npm-packages-in-one-command",
    "timeToRead": 1,
    "type": "scribble",
    "number": 28,
    "previous": {
      "slug": "/scribbles/free-photoshop-like-experience-with-photopea",
      "title": "Free Photoshop-like experience with Photopea",
      "number": 27
    },
    "next": {
      "slug": "/scribbles/my-git-config",
      "title": "My Git Config",
      "number": 29
    }
  },
  {
    "title": "My Git Config",
    "abstract": "This is a copy of my Git configuration file.\n",
    "date": new Date("2025-12-19T00:00:00.000Z"),
    "cover": "/hero/git.png",
    "credit": "Vasil Enchev",
    "creditLink": "https://dribbble.com/shots/4037272-Git-monster-illustration/attachments/925202",
    "creditSource": "dribbble.com",
    "tags": [
      "Technical",
      "Git",
      "Terminal"
    ],
    "content": "```text\n[user]\n    name = Clarice Bouwer\n    email =\n    signingKey = \"\"\n[alias]\n    pp = log --graph --abbrev-commit --decorate --date=relative --all\n    st = status --short --branch\n    lg = log --pretty='%C(yellow)%h%Creset | %C(yellow)%d%Creset %s %Cgreen(%c\n    hist = log --pretty=format:\\\"%h %ad | %s%d [%an]\\\" --graph --date=short\n    dp = diff --word-diff --unified=10\n    s = status\n    a = add\n    cm = commit -m\n    pushall = !git remote | xargs -L1 git push --all\n    lg2 = log\n    co = checkout\n[diff]\n    algorithm = histogram\n[core]\n    pager = less -RFX\n    autocrlf = input\n    editor = vim\n[pull]\n    rebase = false\n[init]\n    defaultBranch = \"main\"\n[gpg]\n    program = gpg\n[commit]\n    gpgSign = false\n[tag]\n    forceSignAnnotated = false\n[color]\n    ui = always\n```",
    "_meta": {
      "filePath": "2025-12-22-git-config.md",
      "fileName": "2025-12-22-git-config.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-12-22-git-config"
    },
    "slug": "/scribbles/my-git-config",
    "timeToRead": 1,
    "type": "scribble",
    "number": 29,
    "previous": {
      "slug": "/scribbles/automatically-update-npm-packages-in-one-command",
      "title": "Automatically update npm packages in one command",
      "number": 28
    },
    "next": {
      "slug": "/scribbles/how-to-kill-an-orphaned-next-js-dev-server",
      "title": "How to kill an orphaned Next.js dev server",
      "number": 30
    }
  },
  {
    "title": "How to kill an orphaned Next.js dev server",
    "abstract": "Do you have an orphaned Next.js dev server holding port 3000 captive? Here's a clean, safe command to kill it and avoid port conflicts.\n",
    "date": new Date("2026-04-18T00:00:00.000Z"),
    "tags": [
      "Technical",
      "Tip",
      "Terminal"
    ],
    "content": "Next.js dev servers can get orphaned — if your terminal crashes, you close a tab, or a script exits unexpectedly, the next dev process keeps running in the background, holding port 3000 captive.\n\nRunning this command is a clean, safe way to sweep those zombie processes before starting a fresh dev server, avoiding the dreaded `EADDRINUSE: address already` in use port conflict error or having the dev server open on a new port.\n\n```bash\npkill -f \"next dev\" 2>/dev/null; echo \"Stopped any running Next.js dev server\"\n```\n\nLet's break it down:\n\n- pkill sends a termination signal (`SIGTERM`) to matching processes\n\n- `-f` matches against the full command line, not just the process name — so it finds processes where next dev appears anywhere in the command string\n  This kills any process running next dev, which is the Next.js development server\n\n- `2>/dev/null` Redirects stderr (file descriptor 2 - see below) to /dev/null (the void)\n  Suppresses the error message pkill prints when no matching process is found — keeps output clean whether or not a server was actually running\n\n- `; echo \"...\"` The `;` runs the echo unconditionally (regardless of pkill's exit code)\n  Prints a confirmation message so you know the command ran\n\n---\n\n## File descriptors\n\nIn Unix, every process gets three standard file descriptors opened automatically:\n\n| FD  | Name   | Default destination      |\n| --- | ------ | ------------------------ |\n| 0   | stdin  | keyboard input           |\n| 1   | stdout | terminal (normal output) |\n| 2   | stderr | terminal (error output)  |\n\nFD 2 (stderr) is where programs write error messages and diagnostics — separate from regular output so you can redirect them independently.\n\nThat's why `2>/dev/null` silences only errors while letting normal output through, and why `>/dev/null` (shorthand for `1>/dev/null`) silences only normal output.",
    "_meta": {
      "filePath": "2026-01-19-kill-nextjs.md",
      "fileName": "2026-01-19-kill-nextjs.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-01-19-kill-nextjs"
    },
    "slug": "/scribbles/how-to-kill-an-orphaned-next-js-dev-server",
    "timeToRead": 2,
    "cover": "/hero/default-01.jpg",
    "type": "scribble",
    "number": 30,
    "previous": {
      "slug": "/scribbles/my-git-config",
      "title": "My Git Config",
      "number": 29
    },
    "next": {
      "slug": "/scribbles/use-react-hooks-inside-an-mdx-story-in-storybook",
      "title": "Use React hooks inside an MDX story in Storybook",
      "number": 1
    }
  }
]